export const getPercentEndTerm = (
  mouth,
  currency,
  replenishment,
  procentEndTerm
) => {
  if (mouth === 0.23) {
    if (currency === "uah") {
      if (replenishment && !procentEndTerm) {
        return 4.0
      } else if (procentEndTerm && !replenishment) {
        return 7.75
      } else if (replenishment && procentEndTerm) {
        return 7.5
      } else {
        return 9.0
      }
    } else if (currency === "usd") {
      if (replenishment && !procentEndTerm) {
        return 0.0
      } else if (procentEndTerm && !replenishment) {
        return 0.0
      } else if (replenishment && procentEndTerm) {
        return 0.0
      } else {
        return 0.0
      }
    } else if (currency === "eur") {
      if (replenishment && !procentEndTerm) {
        return 0.0
      } else if (procentEndTerm && !replenishment) {
        return 0.0
      } else if (replenishment && procentEndTerm) {
        return 0.0
      } else {
        return 0.0
      }
    }
  }
  if (mouth === 1) {
    if (currency === "uah") {
      if (replenishment && !procentEndTerm) {
        return 10.5
      } else if (procentEndTerm && !replenishment) {
        return 7.75
      } else if (replenishment && procentEndTerm) {
        return 7.5
      } else {
        return 11.0
      }
    } else if (currency === "usd") {
      if (replenishment && !procentEndTerm) {
        return 0.0
      } else if (procentEndTerm && !replenishment) {
        return 0.0
      } else if (replenishment && procentEndTerm) {
        return 0.0
      } else {
        return 0.0
      }
    } else if (currency === "eur") {
      if (replenishment && !procentEndTerm) {
        return 0.0
      } else if (procentEndTerm && !replenishment) {
        return 0.0
      } else if (replenishment && procentEndTerm) {
        return 0.0
      } else {
        return 0.0
      }
    }
  }
  if (mouth === 3) {
    if (currency === "uah") {
      if (replenishment && !procentEndTerm) {
        return 11.5
      } else if (procentEndTerm && !replenishment) {
        return 7.75
      } else if (replenishment && procentEndTerm) {
        return 7.5
      } else {
        return 12.0
      }
    } else if (currency === "usd") {
      if (replenishment && !procentEndTerm) {
        return 0.9
      } else if (procentEndTerm && !replenishment) {
        return 0.0
      } else if (replenishment && procentEndTerm) {
        return 0.0
      } else {
        return 1.0
      }
    } else if (currency === "eur") {
      if (replenishment && !procentEndTerm) {
        return 0.65
      } else if (procentEndTerm && !replenishment) {
        return 0.0
      } else if (replenishment && procentEndTerm) {
        return 0.0
      } else {
        return 0.75
      }
    }
  }
  if (mouth === 6) {
    if (currency === "uah") {
      if (replenishment && !procentEndTerm) {
        return 12.5
      } else if (procentEndTerm && !replenishment) {
        return 8.25
      } else if (replenishment && procentEndTerm) {
        return 8.0
      } else {
        return 15.5
      }
    } else if (currency === "usd") {
      if (replenishment && !procentEndTerm) {
        return 1.3
      } else if (procentEndTerm && !replenishment) {
        return 0.01
      } else if (replenishment && procentEndTerm) {
        return 0.01
      } else {
        return 1.4
      }
    } else if (currency === "eur") {
      if (replenishment && !procentEndTerm) {
        return 0.9
      } else if (procentEndTerm && !replenishment) {
        return 0.01
      } else if (replenishment && procentEndTerm) {
        return 0.01
      } else {
        return 1.0
      }
    }
  }
  if (mouth === 9) {
    if (currency === "uah") {
      if (replenishment && !procentEndTerm) {
        return 12.5
      } else if (procentEndTerm && !replenishment) {
        return 8.75
      } else if (replenishment && procentEndTerm) {
        return 8.5
      } else {
        return 16.0
      }
    } else if (currency === "usd") {
      if (replenishment && !procentEndTerm) {
        return 1.4
      } else if (procentEndTerm && !replenishment) {
        return 0.15
      } else if (replenishment && procentEndTerm) {
        return 0.05
      } else {
        return 1.5
      }
    } else if (currency === "eur") {
      if (replenishment && !procentEndTerm) {
        return 1.1
      } else if (procentEndTerm && !replenishment) {
        return 0.01
      } else if (replenishment && procentEndTerm) {
        return 0.01
      } else {
        return 1.2
      }
    }
  }
  if (mouth === 12) {
    if (currency === "uah") {
      if (replenishment && !procentEndTerm) {
        return 12.5
      } else if (procentEndTerm && !replenishment) {
        return 9.25
      } else if (replenishment && procentEndTerm) {
        return 9.0
      } else {
        return 16.0
      }
    } else if (currency === "usd") {
      if (replenishment && !procentEndTerm) {
        return 2.2
      } else if (procentEndTerm && !replenishment) {
        return 0.35
      } else if (replenishment && procentEndTerm) {
        return 0.25
      } else {
        return 2.3
      }
    } else if (currency === "eur") {
      if (replenishment && !procentEndTerm) {
        return 1.9
      } else if (procentEndTerm && !replenishment) {
        return 0.1
      } else if (replenishment && procentEndTerm) {
        return 0.05
      } else {
        return 2.0
      }
    }
  }
  if (mouth === 18) {
    if (currency === "uah") {
      if (replenishment && !procentEndTerm) {
        return 12.5
      } else if (procentEndTerm && !replenishment) {
        return 9.25
      } else if (replenishment && procentEndTerm) {
        return 9.0
      } else {
        return 13.0
      }
    } else if (currency === "usd") {
      if (replenishment && !procentEndTerm) {
        return 1.4
      } else if (procentEndTerm && !replenishment) {
        return 0.35
      } else if (replenishment && procentEndTerm) {
        return 0.25
      } else {
        return 1.5
      }
    } else if (currency === "eur") {
      if (replenishment && !procentEndTerm) {
        return 1.1
      } else if (procentEndTerm && !replenishment) {
        return 0.1
      } else if (replenishment && procentEndTerm) {
        return 0.05
      } else {
        return 1.2
      }
    }
  }
  if (mouth === 24) {
    if (currency === "uah") {
      if (replenishment && !procentEndTerm) {
        return 12.5
      } else if (procentEndTerm && !replenishment) {
        return 8.75
      } else if (replenishment && procentEndTerm) {
        return 8.5
      } else {
        return 13.0
      }
    } else if (currency === "usd") {
      if (replenishment && !procentEndTerm) {
        return 1.4
      } else if (procentEndTerm && !replenishment) {
        return 0.35
      } else if (replenishment && procentEndTerm) {
        return 0.25
      } else {
        return 1.5
      }
    } else if (currency === "eur") {
      if (replenishment && !procentEndTerm) {
        return 1.1
      } else if (procentEndTerm && !replenishment) {
        return 0.1
      } else if (replenishment && procentEndTerm) {
        return 0.05
      } else {
        return 1.2
      }
    }
  }
}

export const getPercentMouthPayment = (
  mouth,
  currency,
  replenishment,
  procentEndTerm
) => {
  if (mouth === 1) {
    if (currency === "uah") {
      if (replenishment && !procentEndTerm) {
        return 10.25
      } else if (procentEndTerm && !replenishment) {
        return 7.5
      } else if (replenishment && procentEndTerm) {
        return 7.25
      } else {
        return 10.75 //bez popovnennya i bez dostrokovogo
      }
    } else if (currency === "usd") {
      if (replenishment && !procentEndTerm) {
        return 0.0
      } else if (procentEndTerm && !replenishment) {
        return 0.0
      } else if (replenishment && procentEndTerm) {
        return 0.0
      } else {
        return 0.0
      }
    } else if (currency === "eur") {
      if (replenishment && !procentEndTerm) {
        return 0.0
      } else if (procentEndTerm && !replenishment) {
        return 0.0
      } else if (replenishment && procentEndTerm) {
        return 0.0
      } else {
        return 0.0
      }
    }
  }
  if (mouth === 3) {
    if (currency === "uah") {
      if (replenishment && !procentEndTerm) {
        return 11.25
      } else if (procentEndTerm && !replenishment) {
        return 7.5
      } else if (replenishment && procentEndTerm) {
        return 7.25
      } else {
        return 11.75
      }
    } else if (currency === "usd") {
      if (replenishment && !procentEndTerm) {
        return 0.8
      } else if (procentEndTerm && !replenishment) {
        return 0.0
      } else if (replenishment && procentEndTerm) {
        return 0.0
      } else {
        return 0.9
      }
    } else if (currency === "eur") {
      if (replenishment && !procentEndTerm) {
        return 0.55
      } else if (procentEndTerm && !replenishment) {
        return 0.0
      } else if (replenishment && procentEndTerm) {
        return 0.0
      } else {
        return 0.65
      }
    }
  }
  if (mouth === 6) {
    if (currency === "uah") {
      if (replenishment && !procentEndTerm) {
        return 12.25
      } else if (procentEndTerm && !replenishment) {
        return 8.0
      } else if (replenishment && procentEndTerm) {
        return 7.75
      } else {
        return 15.00
      }
    } else if (currency === "usd") {
      if (replenishment && !procentEndTerm) {
        return 1.2
      } else if (procentEndTerm && !replenishment) {
        return 0.01
      } else if (replenishment && procentEndTerm) {
        return 0.01
      } else {
        return 1.3
      }
    } else if (currency === "eur") {
      if (replenishment && !procentEndTerm) {
        return 0.8
      } else if (procentEndTerm && !replenishment) {
        return 0.01
      } else if (replenishment && procentEndTerm) {
        return 0.01
      } else {
        return 0.9
      }
    }
  }
  if (mouth === 9) {
    if (currency === "uah") {
      if (replenishment && !procentEndTerm) {
        return 12.25
      } else if (procentEndTerm && !replenishment) {
        return 8.5
      } else if (replenishment && procentEndTerm) {
        return 8.25
      } else {
        return 15.30
      }
    } else if (currency === "usd") {
      if (replenishment && !procentEndTerm) {
        return 1.3
      } else if (procentEndTerm && !replenishment) {
        return 0.1
      } else if (replenishment && procentEndTerm) {
        return 0.01
      } else {
        return 1.4
      }
    } else if (currency === "eur") {
      if (replenishment && !procentEndTerm) {
        return 1.0
      } else if (procentEndTerm && !replenishment) {
        return 0.01
      } else if (replenishment && procentEndTerm) {
        return 0.01
      } else {
        return 1.1
      }
    }
  }
  if (mouth === 12) {
    if (currency === "uah") {
      if (replenishment && !procentEndTerm) {
        return 12.25
      } else if (procentEndTerm && !replenishment) {
        return 9.0
      } else if (replenishment && procentEndTerm) {
        return 8.75
      } else {
        return 15.30
      }
    } else if (currency === "usd") {
      if (replenishment && !procentEndTerm) {
        return 2.1
      } else if (procentEndTerm && !replenishment) {
        return 0.3
      } else if (replenishment && procentEndTerm) {
        return 0.2
      } else {
        return 2.2
      }
    } else if (currency === "eur") {
      if (replenishment && !procentEndTerm) {
        return 1.8
      } else if (procentEndTerm && !replenishment) {
        return 0.05
      } else if (replenishment && procentEndTerm) {
        return 0.01
      } else {
        return 1.9
      }
    }
  }
  if (mouth === 18) {
    if (currency === "uah") {
      if (replenishment && !procentEndTerm) {
        return 12.25
      } else if (procentEndTerm && !replenishment) {
        return 9.0
      } else if (replenishment && procentEndTerm) {
        return 8.75
      } else {
        return 12.75
      }
    } else if (currency === "usd") {
      if (replenishment && !procentEndTerm) {
        return 1.3
      } else if (procentEndTerm && !replenishment) {
        return 0.3
      } else if (replenishment && procentEndTerm) {
        return 0.2
      } else {
        return 1.4
      }
    } else if (currency === "eur") {
      if (replenishment && !procentEndTerm) {
        return 1.0
      } else if (procentEndTerm && !replenishment) {
        return 0.05
      } else if (replenishment && procentEndTerm) {
        return 0.01
      } else {
        return 1.1
      }
    }
  }
  if (mouth === 24) {
    if (currency === "uah") {
      if (replenishment && !procentEndTerm) {
        return 12.25
      } else if (procentEndTerm && !replenishment) {
        return 8.5
      } else if (replenishment && procentEndTerm) {
        return 8.25
      } else {
        return 12.75
      }
    } else if (currency === "usd") {
      if (replenishment && !procentEndTerm) {
        return 1.3
      } else if (procentEndTerm && !replenishment) {
        return 0.3
      } else if (replenishment && procentEndTerm) {
        return 0.2
      } else {
        return 1.4
      }
    } else if (currency === "eur") {
      if (replenishment && !procentEndTerm) {
        return 1.0
      } else if (procentEndTerm && !replenishment) {
        return 0.05
      } else if (replenishment && procentEndTerm) {
        return 0.01
      } else {
        return 1.1
      }
    }
  }
}
